export interface TermoItemContent {
  texto: string;
  level?: number;
}

export interface TermoItem {
  titulo: string;
  itens: {
    numerados?: Record<string, TermoItemContent>;
    naoNumerados?: Array<TermoItemContent>;
  };
}

export interface TermoJson {
  titulo: string;
  descricao: string;
  conclusao: string;
  termo_e_condicoes_de_uso: TermoItem;
  usos_permitidos: TermoItem;
  do_cadastro_na_plataforma: TermoItem;
  exemplo_misto: TermoItem;
  do_uso_da_conta_login_senha: TermoItem;
  responsabilidades: TermoItem;
  da_confidencialidade: TermoItem;
  da_propriedade_intelectual: TermoItem;
  da_politica_de_privacidade: TermoItem;
  das_falhas_na_plataforma: TermoItem;
  prazo_de_vigencia: TermoItem;
  descadastro_da_plataforma: TermoItem;
  disposicoes_gerais: TermoItem;
}

export const termoUsoJson: TermoJson = {
  titulo:
    "TERMO DE USO E CONDIÇÕES GERAIS PARA A UTILIZAÇÃO DA PLATAFORMA SELL.IT PELOS CORRETORES",
  descricao: `
    Por meio deste instrumento são estabelecidas as condições gerais e o termo de uso
    da plataforma Sell.It ("Plataforma"), desenvolvida pelo grupo Cyrela,
    para que pessoas físicas, regularmente inscritas no Conselho Regional de Corretores
    de Imóveis, (o "Corretor" e, o plural, os "Corretores") possam se cadastrar e passar
    a realizar negócios imobiliários em regime de associação com pessoas jurídicas
    regularmente inscritas no Conselho Regional de Corretores de Imóveis (a "Imobiliária"
    e, o plural, as "Imobiliárias"), estando o uso do aplicativo condicionado à concordância
    e à adesão integral a esse Termo de Uso e Condições Gerais para a Utilização da
    Plataforma ("Termo") e da celebração do Contrato de Associação ("Contrato") entre o
    Corretor e a Imobiliária.
  `,
  conclusao: `
    TODA E QUALQUER PESSOA FÍSICA OU JURÍDICA QUE SE TORNAR USUÁRIA DA
PLATAFORMA DECLARA ACEITAR OS TERMOS E CONDIÇOES DE USO ACIMA
DESCRITOS
  `,
  termo_e_condicoes_de_uso: {
    titulo: "1. SOBRE O TERMO E CONDIÇÕES DE USO",
    itens: {
      numerados: {
        "1.1": {
          texto: `Toda e qualquer relação entre as Imobiliárias e os Corretores será
          regulada através do Contrato de Associação e, subsidiariamente, pelo presente Termo,
          sendo a adesão ao presente voluntária e indispensável para a utilização da Plataforma e
          ao compartilhamento de informações e oportunidades de negócio. Ao se cadastrar voluntariamente
          e ao utilizar a Plataforma, o Corretor declara ter lido, entendido e aceitado o presente Termo
          de Uso e Condições Gerais para a Utilização da Plataforma.
          `,
          level: 0,
        },
        "1.2": {
          texto:
            "A Sell.It se reserva ao direito de realizar quaisquer alterações, a qualquer momento, no presente Termo, sem a necessidade de aviso prévio, bastando, para tanto, atualizá-lo e disponibilizá-lo em sua última versão para os Corretores.",
          level: 0,
        },
        "1.3": {
          texto:
            "É responsabilidade do Corretor verificar periodicamente as eventuais atualizações do presente Termo. Em caso de discordância, o Corretor deverá cessar a utilização da Plataforma, desinstalá-la e solicitar o cancelamento da sua conta, uma vez que a utilização da mesma está condicionada à aceitação voluntária do Termo de Uso.",
          level: 0,
        },
      },
    },
  },
  usos_permitidos: {
    titulo: "2. DOS USOS PERMITIDOS",
    itens: {
      numerados: {
        "2.1": {
          texto:
            "A Plataforma permite as Imobiliárias disponibilizarem aos Corretores oportunidades de negócios em tempo real, a exemplo do acesso à informações sobre: bens imóveis disponíveis para venda no mercado, detalhamento técnico sobre os imóveis, potenciais pessoas, físicas ou jurídicas, interessadas na aquisição de imóveis; além da possibilidade de solicitar reservas em plantões de venda físicos ou virtuais eventualmente disponibilizados pelas Imobiliárias, entre outras funcionalidades pertinentes ao mercado imobiliário.",
          level: 0,
        },
        "2.2": {
          texto:
            "O uso da Plataforma foi concebido para intermediar a relação associativa entre os Corretores e as Imobiliárias, não devendo ser utilizada para qualquer finalidade que não as expressamente autorizadas por meio do presente Termo.",
          level: 0,
        },
        "2.3": {
          texto:
            "É permitida a transferência temporária de uma cópia da Plataforma por dispositivo, apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, o Corretor não pode, dentre outras questões:",
          level: 0,
        },
      },
      naoNumerados: [
        {
          texto: "Modificar ou copiar os materiais;",
          level: 2,
        },
        {
          texto:
            "Usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);",
          level: 2,
        },
        {
          texto:
            "Tentar descompilar ou fazer engenharia reversa de qualquer software contido no Squad;",
          level: 2,
        },
      ],
    },
  },
  do_cadastro_na_plataforma: {
    titulo: "3. DO CADASTRO NA PLATAFORMA",
    itens: {
      numerados: {
        "3.1": {
          texto:
            "O Corretor declara serem verídicas e precisas todas as informações por ele apresentadas no cadastro necessário para a utilização da Plataforma, especialmente aqueles referentes aos seus dados pessoais, incluindo, mas não se limitando a: nome completo, número de inscrição no CRECI e CPF, cédula de identidade (RG), endereço residencial ou profissional, telefone, assumindo total responsabilidade pela veracidade das informações prestadas, e compromete-se, sempre que for necessário, a atualizá-las antes de realizar novo acesso à Plataforma.",
          level: 0,
        },
        "3.2": {
          texto:
            "A XXXXXX e/ou as Imobiliárias poderão suspender preventivamente o acesso do Corretor à Plataforma, caso tome conhecimento, por qualquer motivo, de informações imprecisas ou inverídicas fornecidas pelo Corretor em seu cadastro, podendo restabelecê-lo tão logo o Corretor corrija ou confirme tais informações.",
          level: 0,
        },
        "3.2.1": {
          texto:
            "O Corretor que tomar ciência, por qualquer motivo, de informações imprecisas ou inverídicas constantes do seu cadastro, deverá notificar as Imobiliárias, através da Plataforma, requisitando a alteração desses dados.",
          level: 0,
        },
        "3.2.2": {
          texto:
            "Caso a Sell.It e/ou as Imobiliárias verifiquem a omissão do Corretor quanto às obrigações estipuladas no item 3.2.1, acima, poderá, a seu exclusivo critério, suspender ou cancelar o acesso do Corretor à Plataforma.",
          level: 0,
        },
        "3.3": {
          texto:
            "Após a criação do perfil pessoal, todos os dados poderão ser checados e validados pela Sell.It e/ou as Imobiliárias. Caso seja identificada qualquer informação inexata, a Sell.It e/ou as Imobiliárias poderão, a seu exclusivo critério, solicitar a retificação ou complementação das informações necessárias ou, ainda, rejeitar o cadastro do Corretor, por motivos de segurança.",
          level: 0,
        },
        "3.4": {
          texto:
            "A liberação do perfil na Plataforma não necessariamente ocorrerá no momento imediatamente posterior à validação e checagem dos dados e documentos do Corretor. As Imobiliárias poderão, a seu critério, liberar os perfis na Plataforma de acordo com critérios de mercado e perfil comercial.",
          level: 0,
        },
        "3.5": {
          texto:
            "O Corretor deverá manter todos os seus dados sempre atualizados, sob pena de impossibilidade de acesso, da utilização da Plataforma ou ainda do recebimento dos valores devidos pelas intermediações imobiliárias, não sendo a Sell.It e/ou as Imobiliárias responsáveis, portanto, por qualquer erro ou ausência de pagamento ocasionados por inconsistência nos dados cadastrais.",
          level: 0,
        },
        "3.6": {
          texto:
            "O Corretor cujo acesso à Plataforma for suspenso ou cancelado, não poderá realizar novo Cadastro.",
          level: 0,
        },
        "3.7": {
          texto:
            "Para a utilização da Plataforma, é condição indispensável que o Corretor (a) possua smartphone com tecnologia Android e com acesso à internet ou pacote de dados ativo; (b) faça o download do aplicativo disponível para download gratuito nas lojas virtuais; (c) ative sua conta na Plataforma; e (d) tenha sua conta ativada na Plataforma pela Imobiliária.",
          level: 0,
        },
        "3.8": {
          texto:
            "O Corretor atesta que possui todas as autorizações e documentações necessárias, de acordo com a legislação aplicável para realizar serviços de intermediação imobiliária, assumindo todos os riscos envolvidos na execução de tais atividades e possuindo pleno conhecimento de todos os cuidados necessários para que a atividade seja realizada com a máxima ética, qualidade e segurança.",
          level: 0,
        },
        "3.9": {
          texto:
            "O Corretor reconhece e concorda que a Sell.It e/ou as Imobiliárias não exigem disponibilidade e nem periodicidade do Corretor na execução de suas atividades profissionais, sendo que o Corretor tem autonomia e independência para realizá-las quando, como e se quiser, de acordo com a disponibilidade de oportunidade de negócios disponíveis.",
          level: 0,
        },
        "3.10": {
          texto:
            "Por meio do uso da Plataforma, os Corretores poderão, de acordo com sua conveniência e disponibilidade, reservar posições em plantões de venda presenciais ou virtuais colocados à disposição na Plataforma pelas Imobiliárias.",
          level: 0,
        },
        "3.11": {
          texto:
            "Os Corretores reconhecem que são independentes e não exclusivos, atuando por conta própria e que se utilizam de recursos próprios para a execução de suas atividades profissionais, não havendo, portanto, qualquer subordinação entre os Corretores e a Sell.It e/ou as Imobiliárias. Os Corretores, desde já, reconhecem que a relação jurídica estabelecida por esse Termo não cria vínculo empregatício, societário, mandato, franquia, ou de qualquer outra natureza, salvo aquela decorrente de Contrato Associação que por ventura venha a ser celebrado entre a Imobiliárias e o Corretor.",
          level: 0,
        },
      },
    },
  },
  do_uso_da_conta_login_senha: {
    titulo: "4. DO USO DA CONTA: LOGIN E SENHA",
    itens: {
      numerados: {
        "4.1": {
          texto:
            "O Corretor utilizará a Plataforma por meio de login e senha individuais, responsabilizando-se, em qualquer circunstância, pelo uso que vier a ser feito deles.",
          level: 0,
        },
        "4.2": {
          texto:
            "O Corretor compromete-se a informar imediatamente à XXXXXX e/ou às Imobiliárias acerca da possibilidade de seu login e senha estarem sendo utilizados indevidamente.",
          level: 0,
        },
      },
    },
  },
  responsabilidades: {
    titulo: "5. RESPONSABILIDADES",
    itens: {
      numerados: {
        "5.1": {
          texto:
            "O Corretor reconhece e atesta que tem ciência de todos os riscos envolvidos no exercício de sua atividade profissional e que tem conhecimento dos cuidados necessários para que a prestação dos serviços se desenvolva com ética e segurança.",
          level: 0,
        },
        "5.2": {
          texto:
            "Da mesma forma, o Corretor reconhece que a XXXXXX e/ou as Imobiliárias não têm qualquer obrigatoriedade quanto à oferta mínima de oportunidades de negócio na Plataforma ou de assegurar um valor mínimo de corretagem.",
          level: 0,
        },
      },
      naoNumerados: [
        {
          texto:
            "I - na hipótese de reserva de plantão presencial ou on-line disponibilizado pela Imobiliária, primar pela pontualidade, ciente que o atraso poderá levar à perda na posição do plantão.",
          level: 0,
        },
        {
          texto:
            "II - acionar o suporte da Plataforma, se tiver qualquer problema com o uso do presente aplicativo ou a necessidade de cancelamento da reserva de determinado plantão de vendas presencial ou on-line, para buscar a melhor forma de resolver o problema.",
          level: 0,
        },
        {
          texto:
            "III - responder pelo uso incorreto e/ou indevido da Plataforma.",
          level: 0,
        },
        {
          texto:
            "IV - dispor dos equipamentos necessários para acesso à Plataforma.",
          level: 0,
        },
        {
          texto:
            "V - cumprir todas as leis, regulamentos e normas em âmbito federal, estadual e municipal, inclusive aquela emanada pelos órgãos do sistema COFECI-CRECI, na execução das atividades de intermediação imobiliária.",
          level: 0,
        },
        {
          texto:
            "VI - Por meio de sua aceitação ao presente Termo, reconhece que ficará, a seu exclusivo critério: (i) a escolha do momento em que se conectará à Plataforma; (ii) a opção de reservar ou não posições nos plantões de venda presenciais ou on-line; e (iii) o período, local e quantidade de acessos à Plataforma. O Corretor reconhece que não existe qualquer participação e/ou ingerência da Sell.It e/ou as Imobiliárias nas suas escolhas de utilização da Plataforma, podendo o Corretor acessar e usufruir da Plataforma como melhor lhe couber, desde que respeitados os termos aqui previstos.",
          level: 0,
        },
      ],
    },
  },
  da_confidencialidade: {
    titulo: "6. DA CONFIDENCIALIDADE",
    itens: {
      numerados: {
        "6.1": {
          texto:
            "O Corretor assume, por meio desse Termo, o compromisso de manter sigilo absoluto de todas e quaisquer informações e/ou dados de qualquer natureza da Sell.It e/ou das Imobiliárias, sejam eles da própria empresa, de suas controladas, controladoras, filiais e/ou coligadas, de seus fornecedores, clientes e/ou colaboradores, e/ou dos clientes finais, a que venha a ter acesso em decorrência da utilização da Plataforma e/ou de sua relação com a Sell.It e/ou as Imobiliárias, ficando, assim, proibido de divulgar, revelar, reproduzir ou de qualquer outra forma dispor das informações e/ou dados obtidos por meio da Plataforma e/ou por qualquer outro meio, e de outro lado, obrigando-se a adotar todas as precauções convenientes, razoáveis e/ou necessárias a fim de proteger a integridade das informações e/ou dados da Sell.It e/ou as Imobiliárias, de seus clientes e/ou de seus colaboradores.",
          level: 0,
        },
        "6.2": {
          texto:
            "O Corretor reconhece e concorda que as Informações Confidenciais somente poderão ser utilizadas para finalidades decorrentes ou relacionadas à realização da atividade de intermediação imobiliária, e em nenhuma hipótese para fins que sejam contrários aos interesses da Sell.It e/ou as Imobiliárias e seus clientes.",
          level: 0,
        },
        "6.3": {
          texto:
            "O compromisso de confidencialidade assumido pelo Corretor não será exigível nos casos em que: (i) a revelação, divulgação e/ou reprodução das informações e/ou dados forem previamente autorizadas, por escrito, pela XXXXXX e/ou as Imobiliárias; (ii) as informações e/ou dados tornarem-se disponíveis ao público em geral por qualquer meio que não o descumprimento pelo Corretor do compromisso de confidencialidade previsto nesta Cláusula; ou (iii) a revelação, divulgação e/ou reprodução das informações e/ou dados venham a ser exigidas por lei, autoridade governamental, juiz ou tribunal competentes, sob pena de restar caracterizada desobediência ou outra penalidade, caso em que o Corretor compromete-se a comunicar XXXXXX e as Imobiliárias sobre a exigência formulada no prazo máximo de 48 (quarenta e oito) horas contados da data em que tomar conhecimento dela, e a revelar, divulgar e/ou reproduzir apenas as informações e/ou dados ou sua parte que for necessária para satisfazer tal exigência.",
          level: 0,
        },
      },
    },
  },
  da_propriedade_intelectual: {
    titulo: "7. DA PROPRIEDADE INTELECTUAL",
    itens: {
      numerados: {
        "7.1": {
          texto:
            "Todo o conteúdo disponível na Plataforma, incluindo, mas não se limitando a marcas, logotipos, textos, gráficos, fotografias, vídeos, conteúdo de áudio, telas, programas de computador, bancos de dados, arquivos de transmissão são de propriedade exclusiva da Sell.It e/ou as Imobiliárias, conforme o caso. É proibida a sua cópia, reprodução, distribuição, transmissão, publicação, conexão ou qualquer outro tipo de modificação sem a prévia e expressa autorização da Sell.It e/ou as Imobiliárias.",
          level: 0,
        },
        "7.2": {
          texto:
            "O Corretor declara e reconhece que o download de qualquer conteúdo da Plataforma não lhe confere a propriedade sobre o conteúdo disponível na mesma.",
          level: 0,
        },
        "7.3": {
          texto:
            "Quaisquer marcas exibidas na Plataforma não devem ser consideradas como de domínio público e são de propriedade exclusiva da Sell.It e/ou as Imobiliárias.",
          level: 0,
        },
        "7.4": {
          texto:
            "A reprodução do conteúdo disponível na Plataforma sem a devida autorização e qualquer violação do disposto nesta Cláusula constituirá infração aos direitos de propriedade intelectual e sujeitará o Corretor às sanções administrativas, civis e criminais aplicáveis.",
          level: 0,
        },
      },
    },
  },
  da_politica_de_privacidade: {
    titulo: "8. DA POLÍTICA DE PRIVACIDADE",
    itens: {
      numerados: {
        "8.1": {
          texto:
            "A Sell.It e as Imobiliárias possuem políticas expressas e específicas sobre a privacidade dos dados pessoais dos Corretores (“Política de Privacidade”). Todas as informações dos Corretores estão sujeitas ao tratamento descrito nas referidas Política de Privacidade.",
          level: 0,
        },
        "8.2": {
          texto:
            "O Corretor está ciente que o uso da Plataforma implica na coleta e utilização de informações e dados sobre o Corretor, incluindo eventual transferência, armazenamento, processamento e utilização dos dados pela XXXXXX e Imobiliárias, bem como para envio a autoridades competentes ou ainda para as demais finalidades previstas na Política de Privacidade.",
          level: 0,
        },
        "8.3": {
          texto:
            "O Corretor entende e concorda que a utilização da Plataforma implica na aceitação integral dos termos dispostos na Política de Privacidade, a qual poderá ser consultada nos endereços disponibilizados pela Sell.It e Imobiliárias.",
          level: 0,
        },
      },
    },
  },
  das_falhas_na_plataforma: {
    titulo: "9. DAS FALHAS NA PLATAFORMA",
    itens: {
      numerados: {
        "9.1": {
          texto:
            "A Sell.It e as Imobiliárias não são responsáveis por quaisquer danos, prejuízos ou perdas, de qualquer forma causados ao Corretor, inclusive decorrentes de caso fortuito ou força maior, por falhas na Plataforma, no servidor, na internet e por quaisquer vírus, cavalos de Troia ou outras rotinas de programação de computador que possam danificar, interferir adversamente, que possam ser infiltrados no equipamento do Corretor em decorrência do acesso ou como consequência da transferência de dados, arquivos, imagens, textos ou conteúdo de áudio contidos na Plataforma.",
          level: 0,
        },
        "9.2": {
          texto:
            "A XXXXXX e as Imobiliárias não garantem o acesso e uso contínuo e ininterrupto à Plataforma, a qual poderá não estar disponível por motivos técnicos ou qualquer outra circunstância.",
          level: 0,
        },
      },
    },
  },
  prazo_de_vigencia: {
    titulo: "10. PRAZO DE VIGÊNCIA",
    itens: {
      naoNumerados: [
        {
          texto:
            "O presente termo vigorará por prazo indeterminado, salvo disposição em contrário contida no Contrato de Associação.",
          level: 0,
        },
      ],
    },
  },
  descadastro_da_plataforma: {
    titulo: "11. DESCADASTRAMENTO DA PLATAFORMA",
    itens: {
      numerados: {
        "11.1": {
          texto:
            "Qualquer uma das partes poderá, a qualquer momento, solicitar o descadastro da Plataforma, sem qualquer ônus, quando a outra parte: (i) não observar o disposto nesse Termo e/ou na legislação aplicável; (ii) der causa a danos e/ou prejuízos, diretos ou indiretos à parte contrária.",
          level: 0,
        },
        "11.2": {
          texto:
            "A Sell.It e/ou as Imobiliárias poderá descadastrar definitivamente ou inativar temporariamente o acesso do Corretor à Plataforma, conforme o caso, sem notificação prévia, quando o Corretor: (i) fizer mau uso, uso indevido ou abusivo da Plataforma; (ii) causar danos e/ou prejuízos, diretos ou indiretos, a terceiros ou à Sell.It e/ou as Imobiliárias, devido a atos ou omissões na utilização da Plataforma ou na realização das entregas; (iii) em função de ordem judicial ou requisição legal por autoridade pública competente; (iv) por modificação da Plataforma, perda ou suspensão do registro do Corretor no sistema COFECI-CRECI; (v) por caso fortuito, força maior ou questões de segurança; e (vi) pela suposta prática de qualquer infração ou conduta que implique em violação ao código de ética profissional.",
          level: 0,
        },
        "11.3": {
          texto:
            "O Corretor não fará jus a qualquer indenização ou compensação pelo descadastramento ou inativação temporária de seu acesso à Plataforma.",
          level: 0,
        },
        "11.4": {
          texto:
            "A XXXXXX e/ou as Imobiliárias se reservam ao direito de agir judicialmente e/ou extrajudicialmente em caso de danos sofridos, instruindo processos criminais, cíveis e/ou administrativos nos casos previstos em lei e quando julgar necessário.",
          level: 0,
        },
      },
    },
  },
  disposicoes_gerais: {
    titulo: "12. DISPOSIÇÕES GERAIS",
    itens: {
      numerados: {
        "12.1": {
          texto:
            "Independentemente de qualquer aviso ou notificação prévia ao Corretor, a XXXXXX e/ou as Imobiliárias poderão, a seu exclusivo critério, modificar, suspender ou descontinuar a Plataforma a qualquer tempo e por qualquer motivo, não tendo o Corretor direito a qualquer indenização ou compensação.",
          level: 0,
        },
        "12.2": {
          texto:
            "A eventual tolerância por qualquer das partes quanto ao inexato ou impontual cumprimento das obrigações da outra parte dispostas neste Termo valerá tão somente de forma isolada, não constituindo renúncia ou novação de qualquer espécie.",
          level: 0,
        },
        "12.3": {
          texto:
            "Este termo de uso não importa em qualquer tipo de exclusividade, de forma que o Corretor poderá prestar serviços para quem desejar.",
          level: 0,
        },
        "12.4": {
          texto:
            "Caso qualquer disposição destes Termos se torne nula ou ineficaz, a validade ou eficácia das disposições restantes não será afetada, permanecendo em pleno vigor e efeito.",
          level: 0,
        },
        "12.5": {
          texto:
            "A Sell.It não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica no endosso da Sell.It do site. O uso de qualquer site vinculado é por conta e risco do usuário.",
          level: 0,
        },
        "12.6": {
          texto:
            "Ao cadastrar-se na Plataforma, o Corretor: (i) declara seu aceite incondicional às disposições estipuladas por meio deste Termo; e (ii) autoriza a Sell.It e/ou as Imobiliárias a estabelecer comunicações referentes a este Termo por meio de carta, telegrama, e-mail, SMS, WhatsApp, notificação e outros meios de comunicação que venham ser disponibilizados no futuro para o endereço e e-mail fornecidos pelo Corretor no Cadastro.",
          level: 0,
        },
        "12.7": {
          texto:
            "Lei e Foro. Este Termo será regido e interpretado de acordo com a legislação da República Federativa do Brasil. No caso de qualquer reivindicação ou controvérsia decorrente deste termo, ou a eles relacionada, as Partes elegem desde já o foro da Comarca Sell.It, para a solução da reivindicação ou controvérsia, com a exclusão de qualquer outro, por mais privilegiado que seja.",
          level: 0,
        },
      },
    },
  },

  exemplo_misto: {
    titulo: "3. EXEMPLO COM ITENS MISTOS",
    itens: {
      numerados: {
        "3.1": {
          texto: "Este é um item numerado",
          level: 0,
        },
        "3.2": {
          texto: "Este é outro item numerado",
          level: 0,
        },
      },
      naoNumerados: [
        {
          texto: "Este é um item sem numeração",
          level: 2,
        },
        {
          texto: "Outro item sem numeração",
          level: 2,
        },
      ],
    },
  },
};
